import React, { Component } from "react";
import {
  Configuration,
  exceltodb,
  MandatoryFormFields,
  getDataTable,
  GetNewDrpSheet,
  json2xlsx,
} from "../Configuration";
import AutoCompletemulti from "../Actions/Controls/AutoComplete/autoCompleteMultipleCascad";
import AutoCompletemultiNew from "../Actions/Controls/AutoComplete/autoCompleteMultiple";
import { AttributeRules } from "../CommanFunc";
import { Modal, Spin } from "antd";
import "../ORDER/OrderMaster/style.css";
import "antd/dist/antd.css";
import Moment from "moment";
import AutoCompleteCascad from "../Actions/Controls/AutoComplete/autoComplete.cascad";
import Swal, { swal } from "sweetalert2/dist/sweetalert2.js";
const dataBase = "IMAGEDB";
let files = "";
var tb = "";
const currentDate = Moment().format("DD-MMM-YYYY hh:mm:ss");

export default class frmproductdetails extends Component {
  //Declaring initial State
  constructor(props) {
    super(props);
    this.state = {
      loginId: 0,
      orgid: 0,
      catid1: 0,
      visible: false,
      productdetailsdata: [],
      file: null,
      loading: false,
      portalList: [],
      GroupList: [],
      lotID: "",
      ImportSheetId: "",
      alwCustomSheetval: 0,
      droppedFileName: '',
    };
  }

  //getting organization id from server on component load
  async componentDidMount() {
    let rs = await getDataTable(
      "select orgid from users where userid = " + Configuration.USER_ID
    );
    //updating state values for loginID and orgID from data from server
    this.setState({
      loginId: Configuration.USER_ID,
      orgid: rs[0].orgid,
    });
    // await this.getdata(this.state.loginId, '');
  }

  myChangeHandler = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };
  onAfterSelect(selectedOptions, id, name) {
    if (selectedOptions.length > 0) {
      this.setState({
        [id]: selectedOptions[0].DisplayId,
        [name]: selectedOptions[0].DisplayName,
      });
    } else {
      this.setState({
        [id]: "",
        [name]: "",
      });
    }
    this.forceUpdate();
  }

  async UploadFile() {
    let MandatoryArray = [{ Category: this.state.catid1 }];
    let check = MandatoryFormFields(MandatoryArray);
    if (check == false) {
      return false;
    }

    tb = "";
    if (files) {
      this.setState({ loading: true });
      tb = await exceltodb(files, dataBase, this.state.loginId);
      debugger;
      if (tb) {
        let queCheck =
          "EXEC frmProductDetails_checkSKULimit @tblName = '" +
          tb +
          "' , @loginID = " +
          this.state.loginId;
        let rschk = await getDataTable(queCheck);
        if (rschk[0]["RES"] != "OK") {
          Swal.fire({
            icon: "error",
            title: rschk[0]["RES"],
            showConfirmButton: false,
            timer: 2000,
          });
          this.setState({ loading: false });
          return;
        }
        debugger;
        let PopUpData =
          "EXEC frmProductDetailsPopUpForImportData @tblname =  '" +
          tb +
          "' , @loginID = " +
          this.state.loginId +
          ", @categoryid=" +
          this.state.catid1;
        let ShowPop = await getDataTable(PopUpData);
        if (ShowPop.length > 0) {
          this.setState({ loading: false });
          let result1 = await Swal.fire({
            title: `${ShowPop.length}  SKU ARE ALREADY EXITS DO YOU WANT TO UPDATE IF YES , THEN THE EARLIER DATA WILL BE OVERWRITE `,
            icon: "warning",
            showConfirmButton: true,
            showCancelButton: true,
            showDenyButton: true,
            confirmButtonText: "YES",
            cancelButtonText: "NO",
            denyButtonText: "Generate Excel",
          });

          if (result1.isConfirmed) {
            this.setState({ loading: true });
            let Que =
              "EXEC SaveProductImportDetailsforTest @loginId = " +
              this.state.loginId +
              ",@tblname = '" +
              tb +
              "' , @categoryid=" +
              this.state.catid1;
            let rs = await getDataTable(Que);

            if (Array.isArray(rs)) {
              if (rs.length > 0) {
                this.setState({
                  productdetailsdata: rs,
                  visible: true,
                  loading: false,
                });
                await this.SaveData(this);
              } else {
                Swal.fire({
                  icon: "error",
                  title: "File not Imported Properly",
                  showConfirmButton: false,
                  timer: 1500,
                });
                //alert("File not contain Proper Data")
                this.setState({ loading: false });
              }
            } else {
              Swal.fire({
                icon: "error",
                title: "File not Imported Properly",
                showConfirmButton: false,
                timer: 1500,
              });
              //alert("File not contain Proper Data")
              this.setState({ loading: false });
            }
          } else if (result1.isDenied) {
            await json2xlsx(ShowPop, "EXISTING SKU DATA");
            this.setState({ loading: false });
          } else {
            Swal.fire({
              title: "UPLOAD FAILED",
              icon: "warning",
            });
            this.setState({ loading: false });
          }
          document.getElementById("tp1").value = "";
        } else {
          let Que =
            "EXEC SaveProductImportDetailsforTest @loginId = " +
            this.state.loginId +
            ",@tblname = '" +
            tb +
            "' , @categoryid=" +
            this.state.catid1;
          let rs = await getDataTable(Que);
          debugger;
          if (Array.isArray(rs)) {
            if (rs.length > 0) {
              this.setState({
                productdetailsdata: rs,
                visible: true,
                loading: false,
              });
              await this.SaveData(this);
            } else {
              Swal.fire({
                icon: "error",
                title: "File not Imported Properly",
                showConfirmButton: false,
                timer: 1500,
              });
              //alert("File not contain Proper Data")
              this.setState({ loading: false });
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "File not Imported Properly",
              showConfirmButton: false,
              timer: 1500,
            });
            //alert("File not contain Proper Data")
            this.setState({ loading: false });
          }
          document.getElementById("tp1").value = "";
        }
      } else {
        tb = "";
        this.setState({ loading: false });
        return;
      }
    } else {
      Swal.fire({
        icon: "info",
        title: "File not contain Proper Data",
        showConfirmButton: false,
        timer: 1500,
      });
      this.setState({ loading: false });
      tb = "";
      return false;
    }
  }

  async SaveData() {
    if (!tb) {
      Swal.fire({
        icon: "info",
        title: "File not contain Proper Data",
        showConfirmButton: false,
        timer: 1500,
      });
      //alert("No Data To Save")
    }

    let ltque =
      " SELECT LotID, CAST(LotNo as nvarchar)+'-'+LotName as LotName FROM  LotMaster  ";
    ltque +=
      " OUTER APPLY ( select distinct CategoryId from LotDetails inner join ProductMaster on  ";
    ltque +=
      " 	ProductMaster.ProductID = LotDetails.ProductID where LotID = LotMaster.LotID ) C (blckid) ";
    ltque +=
      " WHERE OrgID = " +
      this.state.orgid +
      " and (DATEDIFF(week,logDate, getDate())<10) and c.blckid =  " +
      this.state.catid1;
    console.log(ltque);
    let lt = await getDataTable(ltque);
    let inputoption = {};
    lt.forEach((ele) => {
      inputoption[ele["LotID"]] = ele["LotName"];
    });
    let ltname = "";
    let ltid = 0;
    let sel = 0;
    if (lt.length <= 0) {
      await Swal.fire({
        title: "ENTER LOT NAME",
        input: "text",
        allowOutsideClick: false,
      }).then(function (result) {
        if (result.isConfirmed) {
          ltname = result.value;
        }
      });
    } else {
      let mrgcnf = await Swal.fire({
        title: "Do you want to merge the data into existing lot?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        allowOutsideClick: false,
      });
      if (mrgcnf.isConfirmed) {
        sel = 1;
        await Swal.fire({
          title: "SELECT LOT NAME",
          input: "select",
          inputOptions: inputoption,
          allowOutsideClick: false,
        }).then(function (result) {
          if (result.isConfirmed) {
            ltid = result.value;
          }
        });
      } else {
        await Swal.fire({
          title: "ENTER LOT NAME",
          input: "text",
          allowOutsideClick: false,
        }).then(function (result) {
          if (result.isConfirmed) {
            ltname = result.value;
          }
        });
      }
    }

    if (sel == 0 && ltname == "") {
      Swal.fire({
        icon: "error",
        title: "Please Enter Lot Name",
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }

    /////////////////////////////////////////////

    let Queery =
      "EXEC Lotcreateandmerge @loginid = " +
      this.state.loginId +
      ",@tblname = '" +
      tb +
      "' , @LotName = '" +
      ltname +
      "' , @Lotid = " +
      ltid;
    this.setState({ loading: true });
    let rss = await getDataTable(Queery);
    let Que =
      "EXEC SaveDataInMasterTable @loginid = " +
      this.state.loginId +
      ",@tblname = '" +
      tb +
      "'";
    let rs = await getDataTable(Que);
    debugger;
    if (rs) {
      Swal.fire({
        icon: "success",
        title: "Data Saved SuccessFully",

        showConfirmButton: false,
        timer: 1500,
      });
      //alert("Data Saved SuccessFully")
      this.setState({ loading: false });
    } else {
      Swal.fire({
        icon: "error",
        title: "SOME ERROR OCCURED",
        showConfirmButton: false,
        timer: 1500,
      });
      //alert("Data Saved SuccessFully")
      this.setState({ loading: false });
    }
  }

  async onAutoCOmpletMultiPleSelect(selectedOptions, name) {
    if (selectedOptions.length > 0) {
      this.setState({
        [name]: selectedOptions,
      });
    } else {
      this.setState({
        [name]: [],
      });
    }
  }

  async ExportErrordata() {
    this.setState({ loading: true });
    let Que =
      "EXEC ExportErrorDataOFExcel @loginID = " +
      this.state.loginId +
      ",@tblNm = '" +
      tb +
      "'";
    let rs = await getDataTable(Que);
    if (rs.length > 0) {
      await GetNewDrpSheet(
        this.state.catid1,
        rs,
        "Error Sheet -" + currentDate + ".xlsx"
      );
      // let que1 = "Drop table " + tb
      // let res = await getDataTable(que1)
      // console.log(res);
      this.setState({ loading: false, productdetailsdata: [] });
    } else {
      Swal.fire({
        icon: "info",
        title: "No Data Found",
        showConfirmButton: false,
        timer: 1500,
      });
      this.setState({ loading: false });
      //alert('No Data Found')
    }
  }

  async ExportRelErrordata() {
    this.setState({ loading: true });
    let Que =
      "EXEC ProductDetails_addRelationShipError @BlockID = " +
      this.state.catid1 +
      ",@tblName = '" +
      tb +
      "'";
    let rs = await getDataTable(Que);
    if (rs.length > 0) {
      await GetNewDrpSheet(
        this.state.catid1,
        rs,
        "Error Rel Sheet -" + currentDate + ".xlsx"
      );
      // let que1 = "Drop table " + tb
      // let res = await getDataTable(que1)
      // console.log(res);
      this.setState({ loading: false, productdetailsdata: [] });
    } else {
      Swal.fire({
        icon: "info",
        title: "No Data Found",
        showConfirmButton: false,
        timer: 1500,
      });
      this.setState({ loading: false });
      //alert('No Data Found')
    }
  }

  // Get Data Of Product
  async getdata(logid, pname) {
    this.setState({ loading: true });
    let Que =
      "EXEC ShowProductList_OrgWise @loginid=" +
      logid +
      " , @productname='" +
      pname +
      "'";
    let rs = await getDataTable(Que);
    if (rs) {
      this.setState({
        productdata: rs,
        loading: false,
      });
    } else {
      this.setState({ loading: false });
      Swal.fire({
        icon: "info",
        title: "No Data Found",
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }
  }

  async getMappingSheet() {
    let MandatoryArray = [{ BLOCK: this.state.catid1 }];
    let check = MandatoryFormFields(MandatoryArray);
    if (check == false) {
      return false;
    }
    this.setState({
      loading: true,
    });
    let ltid = this.state.lotID == "" ? "0" : this.state.lotID;
    let que =
      "EXEC frmProductDetails_getSkuMappingSheet @orgid = " +
      this.state.orgid +
      " , @BlockID = " +
      this.state.catid1 +
      " , @lotName = '" +
      this.state.LotName +
      "' , @LotID = " +
      ltid;
    let rs = await getDataTable(que);
    await GetNewDrpSheet(
      this.state.catid1,
      rs,
      "SKU MAPPING Sheet -" + currentDate + ".xlsx"
    );
    this.setState({
      loading: false,
    });
  }

  async getCustomTemplate() {
    if (this.state.portalList.length + this.state.ImportSheetId.length <= 0) {
      await this.downloadCustomFormat(this);
      return;
    }

    let MandatoryArray = [
      { BLOCK: this.state.catid1 },
      // { "LOT": this.state.lotID }
    ];
    let check = MandatoryFormFields(MandatoryArray);
    if (check == false) {
      return false;
    }

    let brandCheckQuery =
      "SELECT COUNT(*) AS brandCount FROM BrandMaster WHERE OrgID = " +
      this.state.orgid;
    let brandCheckResult = await getDataTable(brandCheckQuery);

    if (brandCheckResult[0].brandCount === 0) {
      // Show an error message if the brand is not created
      debugger;
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Brand Not Created",
        text: "Please Create The Brand First From Brand Master",
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }

    this.setState({
      loading: true,
    });

    let portalIds = this.state.portalList
      .map((ele) => ele["DisplayId"])
      .join(",");
    let importSheetIds = this.state.ImportSheetId.map(
      (ele) => ele["DisplayId"]
    ).join(",");

    let ltid = this.state.lotID === "" ? "0" : this.state.lotID;

    // Set @PortalIDList to '0' if no portal ID is selected
    let portalIDListParam = portalIds !== "" ? portalIds : "0";

    let que =
      "frmProductDetails_getCustomImportSheet @BlockID = " +
      this.state.catid1 +
      " , @PortalIDList ='" +
      portalIDListParam +
      "' , @GroupIDList = '" +
      importSheetIds +
      "' , @LotID = " +
      ltid +
      " , @lotName = '" +
      this.state.LotName +
      "' , @loginID = " +
      this.state.loginId;

    let rs = await getDataTable(que);

    debugger;

    await GetNewDrpSheet(
      this.state.catid1,
      rs,
      "Custom Sheet -" + currentDate + ".xlsx"
    );

    this.setState({
      loading: false,
    });
  }

  myFileChangeHandler = (event) => {
    files = event.target.files[0];
  };

  rulesForNamshi() {
    Modal.info({
      title: "RULES",
      okText: "CLOSE",
      width: Math.min(600, window.innerWidth * 0.92),
      closable: true,
      footer: null,
      bodyStyle: { padding: "14px 18px" },
      style: { top: 70, padding: "0px" },
      maskClosable: true,
      content: (
        <div style={{ fontSize: 12, lineHeight: 1.5 }}>
          <ul>
            <li>Ean code must be fed into Sku Code.</li>
            <li>
              While the colour is changing, select the closest one from the
              dropdown.
            </li>
            <li>
              While feeding the category and gender, select the combination from
              the Namshi sheet.
            </li>
            <li>For Size Run- Refer to final adidas size chart sheet.</li>
            <li>
              For imaging - always select the "other" profile and create links
              only from the adidas GCC organisation.
            </li>
            <li>
              Image angles should be checked during the image process (which
              angle refers to which angle).
            </li>
            <li>
              If the product refers to unisex, then you can select Yes or No
              from the unisex dropdown and then fill in the gender.
            </li>
            <li>
              If a product is only for unisex, then the gender should have a
              "Male" feed.
            </li>
            <li>
              If the age group is "kids," then boys or girls could be selected.
            </li>
          </ul>
        </div>
      ),
    });
  }

  help() {
    const stepStyle = { display: 'flex', gap: 9, marginBottom: 8, alignItems: 'flex-start' };
    const numStyle = {
      minWidth: 22, height: 22, borderRadius: '50%',
      background: '#3D9970', color: '#fff',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontWeight: 700, fontSize: 11, flexShrink: 0,
    };
    const textStyle = { fontSize: 12, color: '#333', lineHeight: 1.5 };
    const sectionStyle = {
      background: '#f5f5f5', borderRadius: 5, padding: '10px 14px',
      marginBottom: 10, borderLeft: '3px solid #3D9970',
    };
    const sectionTitleStyle = {
      fontWeight: 700, fontSize: 12, textTransform: 'uppercase',
      letterSpacing: 0.5, color: '#3D9970', marginBottom: 8,
    };
    const noteStyle = {
      background: '#fffbe6', border: '1px solid #ffe58f',
      borderRadius: 5, padding: '8px 12px', fontSize: 12, color: '#555',
    };

    Modal.info({
      title: "HOW TO USE — IMPORT DATA MASTER",
      okText: "CLOSE",
      width: Math.min(660, window.innerWidth * 0.92),
      closable: true,
      okButtonProps: { style: { display: "none" } },
      footer: null,
      bodyStyle: { padding: "14px 18px" },
      style: { top: 70, padding: "0px" },
      maskClosable: true,
      content: (
        <div>

          {/* Standard Import */}
          <div style={sectionStyle}>
            <div style={sectionTitleStyle}>Standard Import (Default)</div>
            <div style={stepStyle}>
              <div style={numStyle}>1</div>
              <div style={textStyle}><strong>Select Block</strong> — Choose the product category block from the dropdown.</div>
            </div>
            <div style={stepStyle}>
              <div style={numStyle}>2</div>
              <div style={textStyle}><strong>GET IMPORT SHEET</strong> — Click this button to download the standard import template Excel file. Choose the format that matches your product type.</div>
            </div>
            <div style={stepStyle}>
              <div style={numStyle}>3</div>
              <div style={textStyle}><strong>Fill the Template</strong> — Open the downloaded Excel file and fill in your product data. The sheet name <em>must</em> remain <strong>"Sheet1"</strong>.</div>
            </div>
            <div style={stepStyle}>
              <div style={numStyle}>4</div>
              <div style={textStyle}><strong>Choose File</strong> — Click the file picker and select your filled Excel file (.xls / .xlsx).</div>
            </div>
            <div style={stepStyle}>
              <div style={numStyle}>5</div>
              <div style={textStyle}><strong>Upload File</strong> — Click this button to validate and import the data into the system.</div>
            </div>
          </div>

          {/* Custom Sheet Import */}
          <div style={sectionStyle}>
            <div style={sectionTitleStyle}>Custom Sheet Import (Portal-Specific)</div>
            <div style={stepStyle}>
              <div style={numStyle}>1</div>
              <div style={textStyle}><strong>Select Block</strong> — Choose the product category block.</div>
            </div>
            <div style={stepStyle}>
              <div style={numStyle}>2</div>
              <div style={textStyle}><strong>Check "Custom Sheet"</strong> — Tick the checkbox to reveal portal-specific options.</div>
            </div>
            <div style={stepStyle}>
              <div style={numStyle}>3</div>
              <div style={textStyle}><strong>Select Portal</strong> — Choose one or more portals for which you are importing data.</div>
            </div>
            <div style={stepStyle}>
              <div style={numStyle}>4</div>
              <div style={textStyle}><strong>Select Import Sheet</strong> — Pick the import template associated with your selected portal.</div>
            </div>
            <div style={stepStyle}>
              <div style={numStyle}>5</div>
              <div style={textStyle}><strong>Select Lot</strong> — Choose an existing lot to merge into, or a new one will be created during upload.</div>
            </div>
            <div style={stepStyle}>
              <div style={numStyle}>6</div>
              <div style={textStyle}><strong>GET IMPORT SHEET</strong> — Download the portal-specific import template.</div>
            </div>
            <div style={stepStyle}>
              <div style={numStyle}>7</div>
              <div style={textStyle}><strong>Fill &amp; Upload</strong> — Fill the downloaded template, then use <strong>Choose File</strong> → <strong>Upload File</strong> to import.</div>
            </div>
          </div>

          {/* Mapping Sheet */}
          <div style={sectionStyle}>
            <div style={sectionTitleStyle}>SKU Mapping Sheet</div>
            <div style={stepStyle}>
              <div style={{ ...numStyle, background: '#1890ff' }}>i</div>
              <div style={textStyle}><strong>GET MAPPING SHEET</strong> — Downloads a reference sheet listing all SKUs already present in the system for the selected Block and Lot. Use it to avoid duplicate entries before importing.</div>
            </div>
          </div>

          {/* Important Notes */}
          <div style={noteStyle}>
            <strong>⚠ Important Notes</strong>
            <ul style={{ marginTop: 6, marginBottom: 0, paddingLeft: 18 }}>
              <li>Excel sheet tab name must be <strong>"Sheet1"</strong>.</li>
              <li>Column headers must match the template exactly — do not rename them.</li>
              <li>New products not yet in the system will be <strong>created automatically</strong>.</li>
              <li>If a product already exists you will be prompted to update or skip it.</li>
              <li>Only <strong>.xls</strong> and <strong>.xlsx</strong> file formats are accepted.</li>
            </ul>
          </div>

        </div>
      ),
    });
  }

  async ImageHelp() {
    let rs = await getDataTable("EXEC frmProductDetails_ImageHelp");
    const keys = Object.keys(rs[0]);
    Modal.info({
      title: "INSTRUCTION FOR IMAGE ATTRIBUTE",
      okText: "CLOSE",
      width: Math.min(950, window.innerWidth * 0.92),
      closable: true,
      okButtonProps: { style: { display: "none" } },
      footer: null,
      bodyStyle: { padding: 0 },
      style: { top: 70, padding: "0px" },
      maskClosable: true,
      content: (
        <div style={{ overflowX: "auto" }}>
          <table width="100%" style={{ minWidth: 600, fontSize: 12 }}>
            <tr>
              {keys.map((value, index) => {
                return <th>{value}</th>;
              })}
            </tr>
            {rs.map((value, index) => {
              return (
                <tr>
                  {keys.map((value1, index1) => {
                    if (value1 === "Image") {
                      return (
                        <td>
                          <img
                            src={value[value1]}
                            height="100"
                            width="100"
                          ></img>
                        </td>
                      );
                    } else {
                      return <td>{value[value1]}</td>;
                    }
                  })}
                </tr>
              );
            })}
          </table>
        </div>
      ),
    });
  }

  async alwCustomSheet(e) {
    if (e.target.checked) {
      this.setState({ alwCustomSheetval: 1 });
    } else {
      this.setState({ alwCustomSheetval: 0 });
    }
  }

  handleDragOver = (e) => { e.preventDefault(); };

  handleDrop = (e) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile) {
      files = droppedFile;
      this.setState({ droppedFileName: droppedFile.name });
    }
  };

  render() {
    const { droppedFileName } = this.state;

    const sectionHdr = {
      display: 'flex', alignItems: 'center', gap: 10,
      margin: '20px 0 14px',
    };
    const sectionNum = {
      width: 28, height: 28, borderRadius: '50%',
      background: '#3D9970', color: '#fff',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontWeight: 700, fontSize: 14, flexShrink: 0,
    };
    const sectionTitle = { fontSize: 15, fontWeight: 600, color: '#333' };

    const outBtn = {
      border: '1.5px solid #3D9970', color: '#3D9970',
      background: '#fff', borderRadius: 5,
      padding: '5px 14px', fontSize: 13, cursor: 'pointer',
      display: 'inline-flex', alignItems: 'center', gap: 6,
      height: 30, boxSizing: 'border-box', whiteSpace: 'nowrap',
      fontWeight: 500,
    };

    return (
      <div className="content-wrapper">
        <div className="loader" style={{ display: this.state.loading ? 'block' : 'none' }}>
          <div className="loader-item" style={{ marginLeft: '75vh' }}>
            <Spin tip="We are Processing your data! please do not refresh page..." />
          </div>
        </div>

        <section className="content">
          <div id="ctl00_CPHMaincontent_div" className="box box-success" style={{ marginTop: '-13px' }}>

            {/* ── Header ─────────────────────────────────────────────── */}
            <div className="box-header with-border" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '12px 20px' }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 11, color: '#aaa', marginBottom: 3 }}>
                  Dashboard &gt; Import Data &gt; Import Data Master
                </div>
                <h3 className="box-title" style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>
                  Import Data Master
                </h3>
              </div>
              <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginTop: 4 }}>
                {(this.state.loginId === '1' || this.state.loginId === '6') && (
                  <a className="btn btn-sm btn-default" onClick={this.rulesForNamshi}>Rules</a>
                )}
                <a className="btn btn-sm btn-default" onClick={AttributeRules}>Rules</a>
                <button className="btn btn-sm btn-default" onClick={this.help.bind(this)}>Help</button>
                <button className="btn btn-sm btn-default" onClick={this.ImageHelp.bind(this)}>Image Help</button>
              </div>
            </div>

            {/* ── Body ───────────────────────────────────────────────── */}
            <div className="box-body" id="orderDetails" style={{ display: 'block', padding: '8px 24px 24px' }}>

              {/* ① Select Details */}
              <div style={sectionHdr}>
                <div style={sectionNum}>1</div>
                <span style={sectionTitle}>Select Details</span>
              </div>

              <div className="row" style={{ marginBottom: 4 }}>
                {/* Select Block + Custom Sheet checkbox */}
                <div className="col-xs-6 col-sm-6 col-md-2 margintop">
                  <label>Select Block<span className="vcode">*</span></label>
                  <AutoCompleteCascad
                    id="catid"
                    frmNm="FRMALLDATA"
                    quryNm="FILLORGBLOCKS"
                    db="IMAGEDB"
                    filter1="orgid"
                    filterId1={this.state.orgid}
                    filter2=""
                    filterId2=""
                    placeholder="Please Select Block"
                    onAfterSelect={(e) => this.onAfterSelect(e, 'catid1', 'catname1')}
                    isValid={this.state.isValid}
                  />
                  <label style={{ marginTop: '4px', textTransform: 'none', fontSize: '11px', fontWeight: '500', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px', color: '#6B7B82' }}>
                    <input type="checkbox" onClick={this.alwCustomSheet.bind(this)} name="alwCustomSheetval" style={{ margin: '0' }} />
                    Custom Sheet
                  </label>
                </div>

                {/* Custom-sheet extra fields */}
                {this.state.alwCustomSheetval === 1 && (
                  <>
                    <div className="col-xs-6 col-sm-6 col-md-2 margintop">
                      <label>Select Portal</label>
                      <AutoCompletemulti
                        id="articleid"
                        frmNm="FRMATTRIBUTEALIASE"
                        quryNm="FILLPORTAL"
                        db="IMAGEDB"
                        filter2=""
                        filterId2=""
                        filter1="orgid"
                        filterId1={this.state.orgid}
                        placeholder="Please Select Portal"
                        onAfterSelect={(e) => this.onAutoCOmpletMultiPleSelect(e, 'portalList')}
                        isValid={this.state.isValid}
                      />
                    </div>
                    <div className="col-xs-6 col-sm-6 col-md-2 margintop">
                      <label>Select Import Sheet</label>
                      <AutoCompletemulti
                        id="catid"
                        frmNm="FRMPRODUCTDETAILS"
                        quryNm="FILLIMPORTTEMPLATE"
                        db="IMAGEDB"
                        filter2=""
                        filterId2=""
                        filter1="blockid"
                        filterId1={this.state.catid1}
                        placeholder="Please Select Import Sheet"
                        onAfterSelect={(e) => this.onAutoCOmpletMultiPleSelect(e, 'ImportSheetId')}
                        isValid={this.state.isValid}
                      />
                    </div>
                    <div className="col-xs-6 col-sm-6 col-md-2 margintop">
                      <label>Select Lot<span className="vcode">*</span></label>
                      <AutoCompleteCascad
                        id="catid"
                        frmNm="FRMEXPORTDATA"
                        quryNm="FILLLOTALL"
                        db="IMAGEDB"
                        filter1="OrgId"
                        filterId1={this.state.orgid}
                        filter2="CategoryId"
                        filterId2={this.state.catid1}
                        placeholder="Please Select Lot"
                        onAfterSelect={(e) => this.onAfterSelect(e, 'lotID', 'LotName')}
                        isValid={this.state.isValid}
                      />
                    </div>
                  </>
                )}

                {/* Action buttons */}
                <div className="col-xs-12 col-sm-12 col-md-4 margintop">
                  <label>&nbsp;</label>
                  <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 2 }}>
                    <button
                      style={outBtn}
                      onClick={this.state.alwCustomSheetval === 1
                        ? this.getCustomTemplate.bind(this)
                        : this.downloadImportFormat.bind(this)}
                    >
                      <i className="fa fa-download" /> Get Import Sheet
                    </button>
                    <button style={outBtn} onClick={this.getMappingSheet.bind(this)}>
                      <i className="fa fa-download" /> Get Mapping Sheet
                    </button>
                  </div>
                </div>
              </div>

              {/* ② Upload File */}
              <div style={sectionHdr}>
                <div style={sectionNum}>2</div>
                <span style={sectionTitle}>Upload File</span>
              </div>

              <div className="row">
                {/* Drag & Drop zone */}
                <div className="col-xs-12 col-sm-8 col-md-8">
                  <div
                    onDragOver={this.handleDragOver}
                    onDrop={this.handleDrop}
                    onClick={() => document.getElementById('tp1').click()}
                    style={{
                      border: '2px dashed #3D9970', borderRadius: 8,
                      minHeight: 190,
                      display: 'flex', flexDirection: 'column',
                      alignItems: 'center', justifyContent: 'center',
                      padding: '24px 16px', background: '#fafffe', cursor: 'pointer',
                    }}
                  >
                    <i className="fa fa-cloud-upload" style={{ fontSize: 42, color: '#3D9970', marginBottom: 10 }} />
                    <p style={{ fontSize: 14, fontWeight: 600, color: '#333', margin: '0 0 4px' }}>
                      Drag &amp; drop your file here
                    </p>
                    <p style={{ fontSize: 13, color: '#aaa', margin: '0 0 14px' }}>or</p>
                    <label
                      htmlFor="tp1"
                      style={{
                        border: '1.5px solid #3D9970', color: '#3D9970',
                        background: '#fff', borderRadius: 5,
                        padding: '5px 22px', fontSize: 13, cursor: 'pointer',
                        marginBottom: 12, fontWeight: 500,
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      Choose File
                    </label>
                    <input
                      name="fldname"
                      type="file"
                      accept=".xls,.xlsx"
                      id="tp1"
                      onChange={(e) => {
                        this.myFileChangeHandler(e);
                        this.setState({ droppedFileName: e.target.files[0] ? e.target.files[0].name : '' });
                      }}
                      style={{ display: 'none' }}
                      tabIndex={1}
                    />
                    {droppedFileName
                      ? <p style={{ fontSize: 12, color: '#3D9970', margin: '4px 0 0', fontWeight: 600 }}>
                          <i className="fa fa-check-circle" /> {droppedFileName}
                        </p>
                      : <p style={{ fontSize: 11, color: '#bbb', margin: '4px 0 0' }}>
                          Supported formats: .xls, .xlsx &nbsp;|&nbsp; Max file size 20MB
                        </p>
                    }
                  </div>
                </div>

                {/* Guidelines panel */}
                <div className="col-xs-12 col-sm-4 col-md-4">
                  <div style={{ background: '#f9fffe', border: '1px solid #d4ede5', borderRadius: 8, padding: '20px 18px', height: '100%', boxSizing: 'border-box' }}>
                    <p style={{ fontSize: 13, fontWeight: 700, color: '#333', marginBottom: 16, marginTop: 0 }}>
                      Guidelines
                    </p>
                    {[
                      'Download the Import Sheet',
                      'Fill the data in the template',
                      'Upload the completed file',
                      'Validate and process the data',
                    ].map((text, i) => (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
                        <div style={{ width: 22, height: 22, borderRadius: '50%', background: '#3D9970', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, flexShrink: 0 }}>
                          <i className="fa fa-check" />
                        </div>
                        <span style={{ fontSize: 13, color: '#555' }}>{text}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Bottom action row */}
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 20 }}>
                {this.state.visible && (
                  <>
                    <input
                      type="button"
                      value="Export Error Data"
                      onClick={this.ExportErrordata.bind(this)}
                      className="btn btn-danger"
                    />
                    {(this.state.loginId == '10' || this.state.loginId == '1') && (
                      <button onClick={this.ExportRelErrordata.bind(this)} className="btn btn-danger">
                        Export Error<sup>(beta)</sup>
                      </button>
                    )}
                  </>
                )}
                <button
                  className="btn btn-success"
                  onClick={this.UploadFile.bind(this)}
                  style={{ padding: '6px 24px', fontWeight: 600 }}
                >
                  Upload File
                </button>
              </div>

            </div>
          </div>
        </section>
      </div>
    );
  }

  async updateVSDATA() {
    this.setState({ loading: true });
    let Que = "EXEC USP_SetVSData_ForMerc @loginid=" + this.state.loginId;
    let rs = await getDataTable(Que);
    if (rs) {
      this.setState({ loading: false });
      Swal.fire({
        icon: "info",
        title: "Data Successfully Updated",
        showConfirmButton: false,
        timer: 2500,
      });
    }
  }

  async deleteRow(e) {
    let rst = window.confirm("Are you sure want to delete ?");
    if (!rst) {
      return false;
    }
    let pid = e["#ParentID"];
    this.setState({ loading: true });
    let Que =
      "EXEC DeleteProduct @loginid=" + this.state.loginId + " , @pid=" + pid;
    let rs = await getDataTable(Que);
    if (rs) {
      this.setState({ loading: false });
      Swal.fire({
        icon: "info",
        title: "Product Deleted SuccessFully",
        showConfirmButton: false,
        timer: 2500,
      });
      await this.getdata(this.state.loginId, "");
    }
  }

  async downloadImportFormat() {
    let MandatoryArray = [{ Block: this.state.catid1 }];
    let check = MandatoryFormFields(MandatoryArray);
    if (check == false) {
      return false;
    }

    let brandCheckQuery =
      "SELECT COUNT(*) AS brandCount FROM BrandMaster WHERE OrgID = " +
      this.state.orgid;
    let brandCheckResult = await getDataTable(brandCheckQuery);

    if (brandCheckResult[0].brandCount === 0) {
      // Show an error message if the brand is not created
      debugger;
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Brand Not Created",
        text: "Please Create The Brand First From Brand Master",
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }

    let rsst = await getDataTable(
      "SELECT templateid,TamplateName FROM ImportTemplateMaster where TemplateDis = 0 and selectType in (0,1) and CatID = " +
      this.state.catid1
    );
    if (Array.isArray(rsst)) {
      await Modal.info({
        title: "Import Format List",
        okText: "CLOSE",
        okButtonProps: { style: { display: "none" } },
        width: Math.min(600, window.innerWidth * 0.92),
        closable: true,
        footer: null,
        bodyStyle: { padding: "14px 18px" },
        style: { top: 70, padding: "0px" },
        maskClosable: true,
        content: (
          <div>
            {rsst.map((value, index) => {
              return (
                <div style={{ marginTop: "2px" }}>
                  <button
                    className="btn btn-success"
                    onClick={this.ExportFormat.bind(this, value.templateid)}
                  >
                    {value.TamplateName}
                  </button>
                  <br />
                </div>
              );
            })}
          </div>
        ),
      });
    }
  }

  async downloadCustomFormat() {
    let MandatoryArray = [
      { Block: this.state.catid1 },
      { "Import Sheet": this.state.ImportSheetId },
    ];
    let check = MandatoryFormFields(MandatoryArray);
    if (check == false) {
      return false;
    }

    let rsst = await getDataTable(
      "SELECT templateid,TamplateName FROM ImportTemplateMaster where TemplateDis = 0 and selectType in (0,2) and CatID = " +
      this.state.catid1
    );
    if (Array.isArray(rsst)) {
      await Modal.info({
        title: "Import Format List",
        okText: "CLOSE",
        okButtonProps: { style: { display: "none" } },
        width: Math.min(600, window.innerWidth * 0.92),
        closable: true,
        footer: null,
        bodyStyle: { padding: "14px 18px" },
        style: { top: 70, padding: "0px" },
        maskClosable: true,
        content: (
          <div>
            {rsst.map((value, index) => {
              return (
                <div style={{ marginTop: "2px" }}>
                  <button
                    className="btn btn-success"
                    onClick={this.ExportFormat.bind(this, value.templateid)}
                  >
                    {value.TamplateName}
                  </button>
                  <br />
                </div>
              );
            })}
          </div>
        ),
      });
    }
  }

  async ExportFormat(id) {
    this.setState({ loading: true });
    try {
      let sql = "Exec ExcelImportFormatExample @catid =" + id;
      let rs = await getDataTable(sql);
      if (Array.isArray(rs)) {
        let Quue =
          "EXEC GetOption_Value @tempid=" +
          id +
          " , @loginID = " +
          this.state.loginId;
        let rs1 = await fetch(
          Configuration.SYSTEM_SETTINGS.API_URL +
          "GetdrpExcel?que=" +
          Quue +
          "&BlockID=" +
          this.state.catid1
        );
        if (!rs1.ok) {
          throw new Error("Server error: " + rs1.status);
        }
        let str = await rs1.text();
        if (!str || str.startsWith("Error")) {
          throw new Error(str || "Empty response from server");
        }
        let link = document.createElement("a");
        link.href =
          "data:application/vndopenxmlformats-officedocumentspreadsheetmlsheet;base64," +
          str;
        link.setAttribute(
          "download",
          "IMPORTFORMAT-" + this.state.catname1 + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        Swal.fire({
          icon: "info",
          title: "No attribute Found",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text: "Could not generate the import format file. Please ensure the server is running. " + (err.message || ""),
        showConfirmButton: true,
      });
    } finally {
      this.setState({ loading: false });
    }
  }
}
